import invariant from 'invariant';

/*
  Loosly inspired by
  https://stackoverflow.com/questions/42659728/react-proptypes-array-with-specific-length

  This prop type checks weather the value is  [number, number] exactly. If it is used
  in an arrayOf proptype like arrayOf(coord) then this function is passed an array.
  That's why the check is made on type array at the start
  */

function isValid(value) {
  return Array.isArray(value) && value.length === 2 && value.every(Number.isFinite);
}

export default function coord(props, propName, componentName) {
  if (Array.isArray(props)) {
    props.forEach((item, index) => {
      invariant(
        isValid(item),
        `Array item index ${index} is ${item}, but needs to be an array of two numbers`
      );
    });
  }

  const value = props[propName];

  if (!value) return; // not required

  invariant(isValid(value), `${componentName} ${propName} needs to be an array of two numbers`);
}



// WEBPACK FOOTER //
// ./src/propTypes/twoNumbers.js